import { toIsoDate } from "../../utils/dates";
import { LiabilityInterestRateHistory } from "./types";

// History arrives ascending by effectiveDate; a scheduled entry is not current until its date.
export const currentRateOf = (
  history: readonly LiabilityInterestRateHistory[] | undefined,
  now: Date = new Date(),
): LiabilityInterestRateHistory | undefined => {
  const today = toIsoDate(now);
  return history?.findLast((entry) => entry.effectiveDate <= today);
};
